import { Editor, Element as SlateElement } from 'slate'

export const isBlockActive = (editor: Editor, format: string) => {
  //@ts-ignore
  const [match] = Editor.nodes(editor, {
    match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
  })
  return !!match
}
